import React, {PureComponent} from 'react'
// import PropTypes from 'prop-types'
import  './DashboardExecutor.sass'
import  '../../sass/_background.sass'
import List from './List'

export default class DashboardExecutor extends PureComponent {
  // static propTypes = {
  //   uslugasFetch: PropTypes.shape().isRequired
  // }

  render() {
    const {uslugasFetch} = this.props
    return ( uslugasFetch && <List uslugasFetch={uslugasFetch}>Мои услуги</List> )
  }
}



// WEBPACK FOOTER //
// ./components/DashboardExecutor/index.jsx